import { countWords, seniorityFromSelection } from './wizardConstants';

export function emptyWizardForm() {
  return {
    title: '',
    category_id: '',
    employment_type: 'full-time',
    senioritySelection: { entry: false, mid: false, senior: false, lead: false },
    salary_min: '',
    salary_max: '',
    salary_currency: 'EUR',
    salary_period: 'yearly',
    location_eligibility: '',
    location_country: '',
    timezone_requirement: '',
    description: '',
    application_method: 'rwm_flow',
    application_url: '',
    application_email: '',
    skill_ids: [],
  };
}

export function parseApiErrors(data) {
  const errors = {};
  if (data?.errors && typeof data.errors === 'object') {
    Object.entries(data.errors).forEach(([key, messages]) => {
      errors[key] = Array.isArray(messages) ? messages[0] : String(messages);
    });
  } else if (data?.message) {
    errors.submit = data.message;
  }
  return errors;
}

export function validateStep(step, form) {
  const errors = {};

  if (step === 1) {
    if (!form.title.trim()) errors.title = 'Job title is required.';
    if (!form.category_id) errors.category_id = 'Select a category.';
    if (!form.employment_type) errors.employment_type = 'Employment type is required.';
    if (seniorityFromSelection(form.senioritySelection).length < 1) {
      errors.seniority_level = 'Select at least one seniority level.';
    }
  }

  if (step === 2) {
    const min = Number(form.salary_min);
    const max = Number(form.salary_max);
    if (!form.salary_min || min <= 0) errors.salary_min = 'Minimum salary is required.';
    if (!form.salary_max || max <= 0) errors.salary_max = 'Maximum salary is required.';
    if (min > 0 && max > 0 && max < min) {
      errors.salary_max = 'Maximum must be greater than or equal to minimum.';
    }
    if (!form.location_eligibility && !form.location_country) {
      errors.location_eligibility = 'Select a hiring region or a specific country.';
    }
  }

  if (step === 3) {
    if (countWords(form.description) < 100) {
      errors.description = 'Description must be at least 100 words.';
    }
  }

  if (step === 4) {
    if (form.application_method === 'external_url' && !form.application_url.trim()) {
      errors.application_url = 'Application URL is required.';
    }
    if (form.application_method === 'email' && !form.application_email.trim()) {
      errors.application_email = 'Application email is required.';
    }
  }

  return errors;
}
